














































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex'; 
import { store, StoreState, AppSettings } from '../../store';
import * as moment from 'moment';
import axios from 'axios';   
import {saveAs} from 'file-saver';     
import XLSX from 'xlsx'; 
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';       
import util from '../../lib/util';
import newcontact from '../Contact_sprint2/Contact_New.vue'
import { ModelSelect } from 'vue-search-select'

declare interface textMessage {  
		id: string;
		messageId: string;
		from: string;
		to: string;
		text: string;
		time: string;
		direction: "in" | "out";
		state: "received" | "queued" | "sending" | "sent" |"error";
		media: string[];
		temp_Textlist:any[];
		MsgNumbers:any[];
		_hour:number;
		_minite:number,
		EnableMSG_Number:number
		
	}

declare interface selectedNumber {
 phone_number: string;
 text_permissions_level: "none" | "read_only" | "full_access";
}

declare interface TextMessagesData {
 selectedNumber: any;
 messages: textMessage[];
 textContent: string;
}

@Component({
	components: {
   	RotateSquare2,VueElementLoading ,newcontact,ModelSelect
	},
	computed: {
		...mapState({
		'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
		'text_history': (state: StoreState) => state.dashboard.text_history,
		'textmessage_limit': (state: StoreState) => state.dashboard.textmessage_limit,
		'incoming_text': (state: StoreState) => state.dashboard.incoming_text,
		'start_new_text': (state: StoreState) =>state.dashboard.start_newtext,
		'number_being_called': (state: StoreState) => state.dashboard.number_being_called,
		'incommingmessagenotification': (state: StoreState) => state.dashboard.incommingmessagenotification,
		'notifications': (state: StoreState) => state.dashboard.notifications,
		'load_more_text': (state: StoreState) => state.dashboard.load_more_text,
		'onchange_textnumber':(state: StoreState) => state.dashboard.Onchange_textnumber,  
		'Onchange_textnumberstatus':(state: StoreState) => state.dashboard.Onchange_textnumberstatus, 
		'focus_ontext':(state: StoreState) => state.dashboard.foucuson_text,  
		'text_permission_acces':(state: StoreState) =>state.account.text_permissions,
		 'contacts': (state: StoreState) =>state.dashboard.contacts,
		 'textpannel_contactinfo': (state: StoreState) => state.dashboard.textpannel_contactinfo ,
		  'token_id': (state: StoreState) =>state.account.jwt,
		  'selectedfilename':(state:StoreState)=>state.dashboard.selectedfile,
		  'readnotifactionfrom_notifModal': (state: StoreState) =>state.dashboard.readnotifactionfrom_notifModal      
		}),
	},
	beforeDestroy() {
			////Befor destroy clear date values
			this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',false); 
	},
	mounted(){
		 // this.$store.commit('CHANGE_SELECTED_CONTACT', []);

	},
     methods: {
        handleFocusOut() {
              this.$data.issearched=false;
			  this.$data.search='';
        },
    }
})

export default class TextMessages extends Vue {
selectedContact!: object;
downloading:boolean=false;

data() {
		return {
		newcontactmodal:false,
		selectedimageurl:'',
		addnew_contctstatus:'',
		daterangeFormat: "MMM dd, yyyy",
		issearched:false,
		waterMark:"Download Message History",
		open: false,
		textopen:false,
		selectedNumber: null,
		messages: [],  
		suggestionlist:[],
		textContent: "",
		date_status: false,   
		timestamp: '',
		outbound_start_timestamp: null,
		inbound_start_timestamp: null,
		daterange: null,
		sendingText: false,
		sendingImage: false,
		Loader:true,
		temp_Textlist:[],
		MsgNumbers:[],
		msg_que:[],
		Main_Number:'',
		Mobile_Number:'',
		EnableMSG_Number:'',
		text_focus:'',
		minDate : '',
	    maxDate :'',
		maxtodayDate:'',
		FROM_DATEL:'',
		TO_DATEL:'',
		_hour:0,
		_minite:0,
		filename:'',
		start_date: null,
		end_date: null,
		from_number:[],
		FromSelected_Number:'',
		nousermsg:'',
		zoom_image:false,
		Zoomer_image:'',
		_sdate:'',
		_edate:'',
		textsmessage_status:false, 
		__value: "",
		search: '',
		add_icon:false,
		childnodes:[],
		char_max_length:AppSettings.MESSAGE_CHAR_LIMIT,
		newnumber:'',
		startval :null,// new Date().toDateString(),//new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1))).toDateString()),
        endval : null,//new Date().toDateString(),
		existmesg:true,
		} as TextMessagesData
		}

   

	
//   User types in a phone number/contact name and hits enter.
//    The top most item from the search is selected after hitting ‘enter’


//CharacterCount in the input

countChars(event)
{
	debugger	
	const imgvla = document.getElementById('myimg');
		let element = document.getElementById('textvalue');					 
		var searchThis = element.textContent;		 
		var text_max = AppSettings.MESSAGE_CHAR_LIMIT;
		var text_length = searchThis.length; 
			
		if(text_length >= text_max){ console.log('hi');
			const mstStr = searchThis.slice(0, text_max);
			text_length = mstStr.length;
			element.textContent=mstStr;
			event.preventDefault();
		} 
		else{				
			document.getElementsByClassName("character-count")[0].innerHTML = text_length + "/" + text_max;
		}
		document.getElementsByClassName("character-count")[0].innerHTML = text_length + "/" + text_max;
		           			 
}

  onentersuggestionlist(event) 
	{
		console.log('enter suggestion');
		if (event.keyCode === 13) 
		{
		if(this.$data.search.length>0 && this.$data.suggestionlist.length>0)
		{
			this.$data.issearched =this.$data.start_new_text= false;
			let clonedArray = JSON.parse(JSON.stringify(this.$data.suggestionlist));
			this.$data.suggestionlist=[];
			this.$data.issearched = false;
			var sel_cont=clonedArray[0];
			debugger
			this.select_drop(sel_cont);
			this.$store.dispatch("cancel_axios_request").then( (r) => {
				this.$data.Loader=this.$data.existmesg=false;
				this.select_drop(sel_cont);
           } );//cancel the priviose call api and start new one
			
		}
		}
	}

	created() {   
		console.log('getting into created');
		//this.$store.commit('CHANGE_SELECTED_CONTACT', []);
		var filtered = (this as any).text_permission_acces.filter(function (el) {
			return el.text_permissions_level == "full_access";
			});			
			this.$data.from_number=filtered;
		this.$data.maxtodayDate=this.$data.maxDate=this.$data.maxDate=new Date();
		var b=this.tileEnabled;
		if(this.tileEnabled)
		this.$data.temp_Textlist=(this as any).text_history.slice();
		// 	this.$store.dispatch("cancel_axios_request").then( (r) => {
        //    } );
		this.getTexts();
	    //this.loadCheck();
		this.Contact_numbers;
		this.$data.EnableMSG_Number=(this as any).onchange_textnumber;
		var scrolldown;
		//scrolldown = setTimeout(this.scroTobottom, 1000);
	}  

	detail_compnt(){
		 let tags = util.handletag();
		if(tags.length == 0){
			this.$store.dispatch('gettag').then(r=>{
			this.$data.loading_tag=false;
			let taglist = r.data.docs;
			if(taglist.length == 0) return false;
			util.handletag(taglist, 'set');
			})
			.catch(err=>{
			console.log(err);
			})
			return false;
		}
		this.$store.commit('SET_TEXTPNL_CONTACTINFO','Detail_contact')
	}

   
	Create_newcontact(num){		
		var phoneNumber=(this as any).selectedContact.first_name;
		const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
        const matches = phoneNumber.match(re);
        phoneNumber= `${matches[1]}${matches[2]}${matches[3]}`;
		this.$store.commit('NEW_CONTACT_CREATE_WITHNUMBER', phoneNumber);
		this.$data.newnumber=localStorage.mobileNumber =phoneNumber;
	    this.$store.commit('SET_TEXTPNL_CONTACTINFO','New_contact');
		this.$data.add_icon=false;
		this.$router.push({ name: 'ContactsInfo_sp2' });
		this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
		this.$store.commit('SET_TEXTPANEL_CONTACT_SELECTION',true);
	}


	format_PhoneNumber(obj: any) {
		var phoneNumber= `${obj.first_name} ${obj.last_name}`;
		if(obj.contact_status=="new_contact"){
		 return util.formatPhoneNumber(phoneNumber);
		}
		else {
			return `${obj.first_name} ${obj.last_name}`;
		}
    }

	deleverstatusmms(message){
		if(message.direction=='out' && (message.deliveryState ==='not-delivered'|| message.deliveryState ==='failed'))
		{
			return false
		}
	}

	@Watch('start_new_text')
	_startnewtext(){		
		//document.getElementById('textvalue').setAttribute("contenteditable", "false");	
		document.getElementsByClassName("character-count")[0].innerHTML = 0 + "/" + AppSettings.MESSAGE_CHAR_LIMIT;	
		document.getElementById('textvalue').innerHTML = "";
		this.$data.temp_Textlist.length=0
		this.$data.temp_Textlist=[];
		this.$data.suggestionlist=[];
		this.$store.dispatch("cancel_axios_request").then( (r) => {
				this.$data.Loader=this.$data.existmesg=false
           } );//cancel the priviose call api and start new one
		this.$data.issearched = false;
		this.$data.search = '';
		this.$data.start_date = null;
		this.$data.end_date = null;
		this.auto_grow();
	}

	select_drop(obj){
		this.$data.issearched = false;
		this.$store.commit('SET_START_NEWTEXT',false);
	    this.$store.commit('CHANGE_SELECTED_CONTACT', obj);				
		this.$data.search= `${obj.first_name} ${obj.last_name}`;
	    this.$root.$emit('highlight_name' ,{obj});			
	}

	initClick()
	{		console.log('enter init click');
		this.$data.issearched = true;
		var contacts_list=(this as any).contacts;
		var temp=[];
		let mobileNumberList = [];
		let _contacts = contacts_list.filter(obj => {
			if((obj.numbers.mobile.number)&&(obj.numbers.mobile.number.length >= 10)){
				let mobile_number = '';
				mobile_number = ((obj.numbers.mobile.number).indexOf('+1')>-1)? (obj.numbers.mobile.number).toString().replace("+1", ''):obj.numbers.mobile.number ;
				var displayName = `${obj.first_name} ${obj.last_name}`;			  				  
				if((mobileNumberList.length==0) || (mobileNumberList.indexOf(mobile_number)==-1)) {
					mobileNumberList.push(mobile_number);
					temp.push(obj)
				}
				
			}				   				   					  				   				   				   		
		});
		this.$data.suggestionlist=this.Sortlist(temp);
		//document.getElementById('textvalue').setAttribute("contenteditable", "false");
	}
     Sortlist(data){
		data.sort(function(a, b) { 
			const nameA = a.first_name.toLowerCase().trim(),
			nameB = b.first_name.toLowerCase().trim();
			if (nameA < nameB){
			//sort string ascending
			return -1;
			return 0;
			}
		});
		return data;
		}

	validat_num(Number: any){
		let mob_number = Number;
			mob_number = mob_number.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
			if(mob_number.length != 10) return false;      
			if(mob_number.length === 10) {
			mob_number = `+1${mob_number}`;
			}
			else {
				mob_number = `+${mob_number}`;
			}
			return mob_number;
		}

	find_contact(cont)
	{  
		this.$data.addnew_contctstatus='';
		if(!isNaN(cont))
		{
			if(this.validat_num(cont))
			{
				cont=this.validat_num(cont);
				var contacts_list=(this as any).contacts;
				var mmnmssd=this.conacname(cont);
				this.$data.addnew_contctstatus=mmnmssd==undefined?'Add_cont':'';
				if(this.$data.addnew_contctstatus=='Add_cont'){
				this.$data.issearched = false;
				this.$store.commit('SET_START_NEWTEXT',false);
				this.$data.search=cont;
				}
			}
		}
	}
	// clickoutside(e)
	// {
	// 	var tel = document.getElementById("divoutside");
	// 	var sear = document.getElementById("searchbox");
	// 	if(tel)
	// 	{
	// 	this.$data.issearched = false;	 			
	// 	}
	// 	else{
	// 	e.preventDefault();
	// 	}
	// }

	conacname(num){
		var contacts_list=(this as any).contacts;			
        for (const contact of contacts_list) {
            if ((contact as any).numbers && (contact as any).numbers.main) {
                for (const phoneNum of (contact as any).numbers.main) {
                    if (num === phoneNum) {
						 this.$store.commit('CHANGE_SELECTED_CONTACT', contact);
						 this.$data.issearched = false;
						this.$store.commit('SET_START_NEWTEXT',false);
						this.$data.search= `${contact.first_name} ${contact.last_name}`;
						//this.$data.suggestionlist.push(contact);
                          return contact;
                    }
                }
            }
            if ((contact as any).numbers.mobile && (contact as any).numbers.mobile.number) {
                if ((contact as any).numbers.mobile.number === num) {
					 this.$store.commit('CHANGE_SELECTED_CONTACT', contact);
					 this.$data.issearched = false;
					 this.$store.commit('SET_START_NEWTEXT',false);
					 this.$data.search= `${contact.first_name} ${contact.last_name}`;
					//this.$data.suggestionlist.push(contact);
                      return contact;
                }   
            }
        }
	}
	search_inputblur(){
		console.log('enter blur');
     this.$data.notFound ="";
	 this.search_contact();
    //alert('search_inputblur')
     }

	search_contact(){
		console.log('search input');
		this.$data.suggestionlist=[];	
		var temp=[];
		let mobileNumberList = [];
		if(this.$data.search.length>0){
			this.$data.nousermsg = '';
			this.$data.issearched = true;
			var contacts_list=(this as any).contacts;				
			let _contacts = contacts_list.filter(obj => {
				var displayName 
				var from_Name = `${obj.first_name} ${obj.last_name}`;	
				var from_Number = `${obj.numbers.mobile.number}`;
				if((from_Number) && (from_Number.length >=10)){	
					displayName=!isNaN(this.$data.search)? from_Number : from_Name;
					//var displayName = `${obj.first_name} ${obj.last_name}`;	
					var list=  displayName.toLowerCase().includes(this.$data.search.toLowerCase());
						
						if(list)
						{ 
						    let mobile_number = '';
							mobile_number = ((obj.numbers.mobile.number).indexOf('+1')>-1)? (obj.numbers.mobile.number).toString().replace("+1", ''):obj.numbers.mobile.number ;
							
							if((mobileNumberList.length==0) || (mobileNumberList.indexOf(mobile_number)==-1)) {
								mobileNumberList.push(mobile_number);
								temp.push(obj);
								this.$data.suggestionlist=this.Sortlist(temp);//.push(obj);
								this.$data.nousermsg = '';
							}
							
							
						}
				}		
			});
			
			if(this.$data.suggestionlist.length == 0)
			{ var contact={
						first_name: this.validat_num(this.$data.search),//this.$data.search,
						last_name:'',
						contact_status:'new_contact'
						};
						
			var valid_=!isNaN(this.$data.search)&&this.validat_num(this.$data.search);
			this.$data.nousermsg=valid_? this.$data.suggestionlist.push(contact): 'No user found';
			//this.$data.nousermsg = 'No user found';	
			}
		}
		if(this.$data.search.length == 0)
		{
			this.$data.nousermsg = '';
			this.initClick();
		}
	}

	modalImage_zoom(media){
		this.$data.Zoomer_image=media;
		this.$data.zoom_image=!this.$data.zoom_image;//true;
	}

	texthistorydatehandler(args)
	{
		this.$data.start_date = args.startDate;
		this.$data.end_date = args.endDate;
		//this.$data.startval = args.startDate;///: new Date().toDateString(),//new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1))).toDateString()),
        //this.$data.endval = args.endDate;// new Date().toDateString(),
	}

	auto_grow() 
	{
		debugger
		this.$data.textsmessage_status=true;
		var textarea_div=document.getElementById("textvalue") ;
		//if(textarea_div == undefined) textarea_div = (this as any).$refs.text_log;		
		textarea_div.style.padding="8px";
		var mesgsegment_div = document.getElementById("your_div");
		textarea_div.style.height ="5px";//'auto'; 
		if(textarea_div.scrollHeight == 16){
		textarea_div.style.height =	(textarea_div.scrollHeight + 23)+ "px";
		}
		if(textarea_div.scrollHeight == 73){
		textarea_div.style.height =	(textarea_div.scrollHeight - 34)+ "px";
		}
		if(textarea_div.scrollHeight == 132){
		textarea_div.style.height =	(textarea_div.scrollHeight - 94)+ "px";
		}
		else{
		textarea_div.style.height = (textarea_div.scrollHeight+5)+ "px";
		}
		if(textarea_div.style.height=="39px"){mesgsegment_div.style.height=""}
		if(textarea_div.style.height!="39px"){
		  mesgsegment_div.style.height=((document.body.clientHeight-textarea_div.clientHeight)-250)+"px";  
		}
		mesgsegment_div.scrollTop = mesgsegment_div.scrollHeight;
	}

	toggle() 
	 {
		this.$data.open = !this.$data.open;
	 }
	toggletext()
	{
		this.$data.textopen = !this.$data.textopen;
	}
	close() {
		this.$data.open = false;
		this.$data.textopen = false;
	}
							

	Text_URL(text){
			var str =text;
			if(str!=undefined){
			var regex = /((?:ftp|http|https):\/\/(?:\w+:{0,1}\w*@)?(?:\S+)(?::[0-9]+)?(?:\/|\/(?:[\w#!:.?+=&%@!-/]))?)/;
			var result = str.split(regex);
			var data='<div class="content" style="white-space: break-spaces;"><p>';
			for (var i=0;i<result.length;i++)
			{
			if(result[i].indexOf("http")>=0){
			data= data+ " <a href="+result[i]+" target='_blank' style='color: white;text-decoration: underline;'>"+result[i]+"</a>";
			}
			else{
			data = data+" "+ result[i];
			}
			}
			data=data+"</p></div>";
			return data;
			}
			// document.getElementById("wrapper").innerHTML = data;
	}

	//Need to initialize the data property after a computed property
	//has been calculated. This is the cleanest way I could think to do it
	mounted() {
		(this as any).load_more_text=true;
		this.$data.selectedNumber = this.text_permissions[0];
	}

	updated() {
		if( this.text_permissions.length > 0) {
		this.$data.selectedNumber = this.text_permissions[0]
		}
	}

	AddToContact(){
	this.$emit('cancel','cancel_event');
	}

    emaichangr_(indx,evn){  
           this.$data.email_data=this.$data.FromSelected_Number=evn.phone_number;
      }

	Onchange_getext(indx,evn){
		console.log('evn.phonenumber',evn.phone_number);
		this.$data.FromSelected_Number=evn.phone_number;;//event.target.value;
		this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',true);
		this.$store.commit('SET_NUMBER_BEING_CALLED', null);
		this.getTexts();
	}

	// Called from the dashboard component. Used to set the selected
	// number when a notification is clicked.
	setSelectedNumber(notification_number) {
		for(const number of this.text_permissions) {
		if (notification_number === (number as any).phone_number) {
		this.$data.selectedNumber = number;
		this.getTexts();
		break;
		}
		}
	}

	// "If a user has privilege level none for a phone number then the user
	// should not be able to use that number for texting. This means that number
	// should not be displayed/included in the from dropdown described above."
	// -Section 3.2.1
	get text_permissions() {
		if(store.state.account.text_permissions && Array.isArray(store.state.account.text_permissions)) {
		return store.state.account.text_permissions.filter((e) => {
		return (e as any).text_permissions_level !== "none";
		});
		} else {
		return [];
		}
	}

	// "If the caller/contact does not have a number that is
	// text enabled, or the contact did not give permission to be sent texts,
	// then leave the Text Messages tile empty/unpopulated and greyed out
	// (i.e. inactive)." - Section 3.2.1

	//Also checking to see if the user has any devices with text permission,
	//and whether the contact has a mobile number
	get tileEnabled() {
		//alert('tileEnabled')
		if
		(
		this.text_permissions &&
		this.text_permissions.length > 0 &&
		this.selectedContact &&
		(this.selectedContact as any).numbers &&(
		(this.selectedContact as any).numbers.mobile ||
		(this.selectedContact as any).numbers.main)
		)
		{
		return true;
		}
		return false;
	}

   //This check is run to see if the input area should be disabled
	get canSend() {
			if(
			this.$data.selectedNumber &&
			this.$data.selectedNumber.text_permissions_level === "full_access"
			)
			{
			return true;
			}
			return false;
	}

	get fullName() {
		if(this.selectedContact) {
		return `${(this.selectedContact as any).first_name} ${(this.selectedContact as any).last_name}`;
		}
		return "";
	}

	// This is only here to make working with v-for easier.
	// get reverseLog() {
	// this.$data.temp_Textlist=(this as any).text_history.slice();
	// return this.$data.temp_Textlist;
	// }

	@Watch('text_history')
	Loadmoretext() 
	{
		
		let loadmore = false;
		if((this as any).text_history.length>0) {
			this.$data.temp_Textlist=(this as any).text_history.slice();
			const timestamp = (this as any).text_history[0].time;
			var fromdate = this.$data.minDate;
			loadmore = moment(timestamp).isAfter(fromdate, 'day') && (this as any).load_more_text;	
			
		}
		
		
		if (loadmore &&  this.downloading)
		{
			this.loadCheck();
		}
		else if (this.downloading)
		{
		this.downloading=false;
		var self =this;
		setTimeout(function(){
		self.TextExcelDoc_download();   
		}, 1000);
		}
	}

	@Watch('number_being_called')
	onNumberBeingCalledChange() {
	this.setSelectedNumber((this as any).number_being_called);
	}



	@Watch('incoming_text')
	onIncomingText() { 
		//alert('incoming')
		this.$data.EnableMSG_Number=(this as any).onchange_textnumber;
		if(	((this as any).incoming_text.to ===this.$data.selectedNumber.phone_number && 
		(this as any).incoming_text.from ===  this.$data.EnableMSG_Number) ||
		((this as any).incoming_text.from ===  this.$data.EnableMSG_Number &&
		(this as any).incoming_text.to === (this as any).selectedContact.numbers.mobile.number) )
		{
		var ntf= (this as any).incommingmessagenotification;
		this.$store.dispatch('markNotificationAsRead', ntf);

		this.$store.commit('DELETE_NOTIFICATION', {notificationId:ntf.id});
		this.$store.commit('APPEND_NEW_TEXTS', [(this as any).incoming_text]);
		var scrolldown;// = setTimeout(this.scroTobottom, 1000);
		var myDiv=(this as any).$refs.text_log;
		//myDiv.scrollTop = myDiv.scrollHeight+ 200;
		scrolldown = setTimeout(this.scroTobottomtext, 1000);
		}
	}  

	//Need to make an API request when the selected contact changes
	@Watch('selectedContact')
	onSelectedContactChange() {
		var selectedCont=(this as any).selectedContact; 
		document.getElementsByClassName("character-count")[0].innerHTML = 0 + "/" + AppSettings.MESSAGE_CHAR_LIMIT;
		//cancel the priviose call api and start new one
		this.$store.dispatch("cancel_axios_request").then( (r) => 
		{
		this.$data.Loader=this.$data.existmesg= selectedCont!=null? true:false;
		this.$store.commit('SET_TEXT_HISTORY', []);
        } );
		if (!selectedCont) return; 
		this.$store.commit('SET_ONCHANGETEXTNUMBER_STATUS',false);
		this.TO_NUM1((this as any).selectedContact);
		this.$data.outbound_start_timestamp = null;
		this.$data.inbound_start_timestamp = null;
		this.$data.start_date=null;
		this.$data.end_date=null  ;
		this.auto_grow();
		const el=document.getElementById('textvalue');		
		// if(selectedCont.numbers.mobile.number == "" || selectedCont.numbers.mobile.number == "+1+"){
        // el.contentEditable = "false";		
		// }
		// else{
		// 	el.contentEditable = "true";
		// }				
		if(el)el.innerHTML = "";		
		 this.getTexts();
	}
	@Watch('readnotifactionfrom_notifModal')
	open_textchain_frommodal(){
			if((this as any).readnotifactionfrom_notifModal){
				this.scroTobottom();
			}
	}
	scroTobottom()
	{  
		var focs=(this as any).focus_ontext;
		
		this.$data.text_focus=focs;
		let el = document.getElementById(focs);
		var objDiv = document.getElementById("your_div");
		 document.getElementById("your_div").focus();
        objDiv.scrollTop = objDiv.scrollHeight - objDiv.clientHeight; 
		var myDiv=(this as any).$refs.text_log;
		//this.$store.commit('SET_FOCUSTEXT', '');
		// Get the bounding rectangle so we can get the element position position
		if(el==null && objDiv!=null)
		{
		myDiv.scrollTop = myDiv.scrollHeight;//+ 200; 
		}		
		else{
		el.scrollIntoView({ block: 'end'});
		}		
	}; 

    
   TO_NUM1(selectedCont){
	   var meg_number;
	   if(selectedCont!=null){
	   if(selectedCont.contact_status=="new_contact"){
		    meg_number=selectedCont.first_name;
          this.$store.commit('SET_NUMBER_ONCHANGE_TEXTMESSG',selectedCont.first_name);
		}
		else{
		if ((!selectedCont)  ||!selectedCont.numbers)
		return;
		 meg_number=selectedCont.numbers.mobile.number; 
		if (meg_number.length<1 && selectedCont.numbers.main.length>0)
		meg_number = selectedCont.numbers.main[0];
		meg_number=meg_number==""?selectedCont.numbers.main[0]:meg_number;
		var Onchange_number= (this as any).Onchange_textnumberstatus;  
		this.$data.EnableMSG_Number=Onchange_number?this.$data.EnableMSG_Number: meg_number;
		meg_number=Onchange_number?this.$data.EnableMSG_Number: meg_number;
		this.$store.commit('SET_NUMBER_ONCHANGE_TEXTMESSG',meg_number)	;
		this.Contact_numbers;
		}
		return  this.val_num(meg_number);;
	   }
   }
  
    val_num(num){
     var modf_num= num.toString().indexOf("+1") == -1 ? "+1"+num :  num;
	 return modf_num;
	}	

	 onenterimagetext(event)
	{ console.log('here only');
		let val = document.getElementById('textvalue');			
		if(event.key == "Enter" && this.$data.filename!=''){	 console.log('here only after enter',this.$data.filename);		
			if(this.$data.filename!='' && this.$data.filename!=undefined && this.$data.filename!=null){
				
				let save_image ='';
				save_image =  this.$data.filename;
				this.$data.textContent = '';
				if(save_image!='') {this.$data.filename='';}
				console.log('ether');
				(this.$refs.fileInputTextPanel as any).value = null;
				const img = document.getElementById('myimg');
				val.innerText = '';
				if(img)	img.remove();				
				this.$store.commit('SET_SELECTED_FILE','');
				this.fileUploaded(save_image);			 	
				this.auto_grow();					
			  }
			  else{
				console.log('orrr');
				console.log('this.$data.textContent here',this.$data.textContent)					 		 
				document.getElementsByClassName("character-count")[0].innerHTML = "0/"+AppSettings.MESSAGE_CHAR_LIMIT;
				this.$store.commit('SET_SELECTED_FILE','');
				this.$data.textContent = '';
				let el = document.getElementById('myimg');
				if(el){
					el.remove();
				}
				/*else{
					const elem = document.createElement("img");
					const img1 = 	document.getElementById("textvalue").appendChild(elem);							
					 img1.setAttribute('id','myimg')	
					
				}*/
				/*if(val.innerText.length>0 && val.innerText!=undefined) {
					this.sendText();
				}	*/		
			  
			}
			
		}
		 if(event.key == "Backspace" || event.key == "Delete")
		{   console.log('backspace or delete');
			this.$data.filename = '';
			this.$data.textContent = '';
			let element = document.getElementById('textvalue');	
			this.$store.commit('SET_SELECTED_FILE','')	
		    if(element.innerText!= ""){	
			let elm = document.getElementById('myimg');
			if(elm){
				elm.remove();
			}
			else{												
			const elems  = document.createElement("img");
			const imgl = document.getElementById("textvalue").appendChild(elems);					   		
			imgl.setAttribute('id','myimg');
			}	
		   } 
		  else 
		  {				
			let el = document.getElementById('myimg');
			if(el){
				el.remove();
			}
			else{
			const elem = document.createElement("img");
			const img1 = 	document.getElementById("textvalue").appendChild(elem);							
			img1.setAttribute('id','myimg')										  
			
			}	
			element.innerText = "";
			this.$store.commit('SET_SELECTED_FILE','');
			this.auto_grow();
		  }			  		
		}
		 	
	  }
	

	async sendText() {
		debugger		
		let val = document.getElementById('textvalue'); 
		if((this.$data.textContent.length == 0 ) && (val.innerText.length>0)) 
		{   console.log('here in ',val.innerText);
			this.$data.textContent =  val.innerText;	
			this.$data.msg_que.push(this.$data.textContent);
			if(this.$data.textContent.length>0) {val.innerText = "";}	
			this.$store.commit('SET_FOCUSTEXT', ''); 
			var data=this.$data.temp_Textlist ;
			/*if ((this.$data.textContent.length > 0) || (val.innerText))
			{					
				
			} else{
				this.$data.textContent = val.innerText;
				this.$data.textContent = "";
			}*/
			if (!this.$data.sendingText && this.$data.msg_que.length >0) 
			{
           		var  meg_number= this.TO_NUM1((this as any).selectedContact);
				//var _TO=["+15022576631" , "+15022729312"];   //scott and vasanta
				//var _TO=["+15024420577","+15022576631"];  //john and vasanta
				const  payload = { 
				from:   this.$data.FromSelected_Number.toString().indexOf("+1") == -1 ? "+1"+this.$data.FromSelected_Number :  this.$data.FromSelected_Number,// this.$data.selectedNumber.phone_number,
				to  :    meg_number.toString().indexOf("+1") == -1 ?  "+1" + meg_number :meg_number,
				content: this.$data.msg_que[0],
				contactct:(this as any).selectedContact
				}
				this.$data.msg_que.shift();
				try {
					this.$data.sendingText = true;
					await this.$store.dispatch('sendText', payload).then(async (r)=>{
					
						const msgID = r.data.id;
						document.getElementsByClassName("character-count")[0].innerHTML = 0 + "/" + AppSettings.MESSAGE_CHAR_LIMIT;
						r.data.direction= "out";
						let d= new Date();					 
						r.data.time=  d;
						const strdate= moment(r.data.time).format('YYYY-MM-DD');
						r.data.datex=strdate;	
						var nbn=(this as any).text_history.length;
						if(this.$data.temp_Textlist.length===0 && (this as any).text_history.length==0){
							this.$data.existmesg=true;
						}				
					
						var index1 = this.$data.temp_Textlist.findIndex(x => x.datex ===strdate);
						r.data.displaydate=index1<0;
						r.data.messageId=msgID;
					
						r.data.deliveryState = 'Sending...';
						let newNotification:any = {};
						newNotification._id = r.data.id;
						newNotification.from = payload.from;
						newNotification.to = payload.to;
						newNotification.deliveryState = 'delivered';
						newNotification.messageId = r.data.messageId;
						newNotification.eventType = 'sms';
						newNotification.direction = 'out';
						newNotification.text=r.data.text;
						newNotification.tag=r.data.tag;
						newNotification.applicationId =r.data.applicationId;
						newNotification.time=r.data.time;
						this.$data.temp_Textlist.push(r.data);
					
						(this as any).text_history.push(r.data);
						var data=(this as any).text_history;
						this.$data.textContent="";
						this.text_limitcal(data);
						this.loadCheck(null,false);
						this.auto_grow();
						var scrolldown; 
						const getmessgeinfo=  this.getmessgeinfo;
						var myDiv=(this as any).$refs.text_log;
						//myDiv.scrollTop = myDiv.scrollHeight+ 200;
						scrolldown = setTimeout(this.scroTobottomtext, 1000);
						console.log('r.data.deliveryState before',r.data.deliveryState);
						setTimeout(function() {
						getmessgeinfo(msgID,false,null,newNotification)
						}, 10000)
						console.log('r.data.deliveryState after',r.data.deliveryState);
						//await this.$store.dispatch('newNotification', newNotification); //left side message show
						this.$data.sendingText = false;				
							//this.$store.dispatch('checkNotifications');
						
						//this.sendText();
					});
				} catch(e) {
				} finally {
					this.$data.sendingText = false;				
				}
			}
			else
			{
			}
			return;
		}
	}

	scroTobottomtext(){  
		var myDiv=(this as any).$refs.text_log;
		this.$store.commit('SET_FOCUSTEXT', '');
		var objDiv = document.getElementById("your_div");
        objDiv.scrollTop = objDiv.scrollHeight - objDiv.clientHeight; 
	}; 


	getmessgeinfo(msgID,updatedeliverystatus,messagedata=null,newNotification:any={})
	{
		this.$store.dispatch('getMsgReceipt', msgID).then(async r => {
		if (messagedata==null)
		{
		let array = this.$data.temp_Textlist;
		const filteredMsg = array.filter(ob => ob.messageId === msgID);
		messagedata=filteredMsg[0];
		}
		messagedata.state = r.data.state;
		var deliveryState= r.data.deliveryState;
		console.log('r.data.deliveryState after here',deliveryState);
		messagedata.deliveryState = deliveryState==='Waiting'? 'not-delivered':deliveryState;
		if(Object.keys(newNotification).length!=0) {
			newNotification.text = (deliveryState=='failed') ? 'Message Failed to Send':newNotification.text;
			newNotification.deliveryState=r.data.deliveryState;
			await this.$store.dispatch('newNotification', newNotification);
		}
		//	this.$data.temp_Textlist = [...toRemain, ...filteredMsg];
		if (updatedeliverystatus && messagedata.deliveryState!='Waiting')
		{
		this.$store.dispatch('updateDeliveryStatus',messagedata).then(r => {
	 	});
	   }
		});
	}

	formatPhoneNumber(phoneNumber:string) {
	  return util.formatPhoneNumber(phoneNumber);
	} 

		//(this as any).number_being_called will be set from notificaton(Alert)
		getTexts() {  
			debugger
			console.log('gettting texts');
		  	 this.$data.Loader=true;//this.$data.load_more_text=true;
			 this.$data.msg_que=this.$data.textContent=[];
			 this.$data.FromSelected_Number=(this as any).Onchange_textnumberstatus?this.$data.FromSelected_Number: this.text_permissions[0].phone_number;//:this.$data.FromSelected_Number;
			 this.$data.selectedNumber=(this as any).number_being_called==null? this.$data.FromSelected_Number :(this as any).number_being_called;
				
				this.$data.Loader=(this as any).load_more_text=true;
                var  meg_number= this.TO_NUM1((this as any).selectedContact);
			    this.$data.Loader=true;				
				if((this as any).start_new_text == true){
					this.$data.Loader=false;	
					 this.$data.temp_Textlist.length = 0;
				//document.getElementById('textvalue').setAttribute("contenteditable", "false");
				}				
				this.$data.temp_Textlist=[];
				this.$store.dispatch("getTextHistory", {
					num1: meg_number, 
					num2:this.$data.FromSelected_Number, //this.$data.selectedNumber//"15022646954",//
				}).then((r) => {
				var data=this.$data.temp_Textlist;//=(this as any).text_history.slice();
				this.text_limitcal(data);
				this.$data.existmesg=r.length>0?true:false;;
				this.$data.Loader=(this as any).load_more_text=false;
				if(this.$refs.text_log) { 
				(this.$refs.text_log as any).scrollTop = (this.$refs.text_log as any).scrollHeight;
				}
				this.$data.temp_Textlist=(this as any).text_history.slice();
				var scrolldown;
				scrolldown = setTimeout(this.scroTobottom, 1000);
				this.$data.temp_Textlist.forEach(element => {
					if(element.deliveryState=="waiting"){
     				this.getmessgeinfo(element.messageId,true);
				}
				});
				var ntf= (this as any).incommingmessagenotification;
				this.$store.dispatch('markNotificationAsRead', {notificationId:'12',number:meg_number});
				this.$store.commit('DELETE_NOTIFICATION', {notificationId:'12',number:meg_number}); 
				}).catch((r) => {
					this.$data.Loader = false;
				//this.$data.Loader=(this as any).load_more_text=false;
				//this.$data.temp_Textlist=[];
				});
		}
	
	    text_limitcal(data){
        var dt = new Date();
		var startDate =this.$data._sdate= new Date(dt.getFullYear(), dt.getMonth(), 1);
		var endDate = this.$data._edate=new Date();
		const pastDates = data.filter(x => Date.parse(x.time) >  Date.parse(this.$data._sdate) && Date.parse(x.time) <=  Date.parse(this.$data._edate) );
		var outbound_messages = [];
		pastDates.forEach(doc => {
					if(doc.direction=="out"){
			        outbound_messages.push(doc);
					}
							});
					this.$store.commit('SET_TEXT_LIMIT',outbound_messages.length);
	    }

		get Contact_numbers(){
			var jnb=(this as any).selectedContact;   
			if (!jnb) return; 
			this.$data.Main_Number=jnb.numbers.main[0]; 
			this.$data.Mobile_Number=jnb.numbers.mobile.number;
			this.$data.MsgNumbers=[];
			if(this.$data.Main_Number!="" && this.$data.Mobile_Number!=""){
			if(this.$data.Main_Number== this.$data.Mobile_Number){
			this.$data.MsgNumbers.push( {num:this.$data.Main_Number,_id:0} );  
			}
			else{
			this.$data.MsgNumbers.push( 
			{num:this.$data.Main_Number  ,_id:0} ,
			{num:this.$data.Mobile_Number,_id:1});  
			}
			}
			if(this.$data.Main_Number=="" && this.$data.Mobile_Number!="") { 
			this.$data.MsgNumbers.push({num:this.$data.Mobile_Number,_id:0} );  
			}
			if(this.$data.Main_Number!=""&& this.$data.Mobile_Number=="") { 
			this.$data.MsgNumbers.push(  {num:this.$data.Main_Number,_id:0} );  
			}

			return this.$data.MsgNumbers;
		} 

		loadCheck(e=null,isLoader=true) {
			var myDiv=(this as any).$refs.text_log;
			if(myDiv.scrollTop == 0)
			{
				console.log("Reached the top!");
			if(
			(!this.downloading&&
			this.$refs.text_log && (this.$refs.text_log as any).scrollTop === 0 &&
			this.selectedContact &&
			(this as any).selectedContact.numbers &&
			(this as any).selectedContact.numbers.mobile &&
			(this as any).selectedContact.numbers.mobile.number &&
			this.$data.selectedNumber &&
			this.$data.selectedNumber.phone_number &&
			(this as any).text_history.length > 0
			)
			||
			(this.downloading && e==null)
			//	&& (this as any).load_more_text
			) 
			{
				if(isLoader) {
					this.$data.Loader=true;
				}
			
			const init_height = (this as any).$refs.text_log.scrollHeight;
			const timestamp = (this as any).text_history[0].time;
			
			//const timestamp =  (this as any).temp_Textlist[(this as any).text_history.length - 1].time; //this.$data.temp_Textlist
			this.$store.dispatch('loadMoreTexts', {
			num1: (this as any).selectedContact.numbers.mobile.number,
			num2: this.$data.selectedNumber.phone_number,
			timestamp
			}).then((r) => {
				debugger
				//alert(r)
				var nn=this.$data.temp_Textlist;
				
			if (!this.downloading){
				if(isLoader) {
					this.$data.Loader=false;
				}
			const new_height = (this as any).$refs.text_log.scrollHeight;
			(this.$refs.text_log as any).scrollTop += (new_height - init_height);
			var scrolldown;
			//scrolldown = setTimeout(this.scroTobottom, 1000);
			}
			//this.downloading=false;
			}).catch((r) => {
				this.$data.Loader=false;
			});
			}
			}
		} 

		// onEnterImage(event)
		// {
		// 	debugger
		// 	if(event.keyCode === 13 && ((this as any).selectedfilename))
		// 	{
		// 		this.fileUploaded((this as any).selectedfilename);
		// 		document.getElementById('myimg').setAttribute('src', "");
		// 	}	
		// 	else{
		// 		this.sendText();
		// 	}	
		// }
	
		uploadfile(event)
		{
			debugger	
			
			var textarea_div= document.getElementById("textvalue");	
			textarea_div.innerText='';		
		   	var mesgsegment_div = document.getElementById("your_div");
		textarea_div.style.height ="78px";//'auto'; 
		textarea_div.style.height = (textarea_div.scrollHeight+78)+ "px";		
		 if(textarea_div.style.height=="39px"){mesgsegment_div.style.height=""}
		if(textarea_div.style.height!="39px"){
		  mesgsegment_div.style.height=((document.body.clientHeight-textarea_div.clientHeight)-250)+"px";  
		}
		mesgsegment_div.scrollTop = mesgsegment_div.scrollHeight;	
			this.$data.filename = event.target.files[0];
			
			this.$store.commit('SET_SELECTED_FILE',this.$data.filename);
	        const val = URL.createObjectURL(event.target.files[0]);
			// this.$data.selectedimageurl = val;	

			const img = document.getElementById('myimg');
			if(!img){
				const elem = document.createElement("img");
			const img1 = 	document.getElementById("textvalue").appendChild(elem);							
			img1.setAttribute('id','myimg');
			img1.setAttribute('src',val);
			img1.style.height = "116px";
			img1.style.width = "100%";
			event.target.value = '';
			}	
			else{					
			img.setAttribute('src',val);
			img.style.height = "116px";
			img.style.width = "100%";
			event.target.value = '';					
			}		console.log('here inside here');		
			window.addEventListener('keydown', this.onenterimagetext)		
		}		
			

	    fileUploaded(files) {
			debugger
		var FileSize=files.size;
		var Max_fileSize=Math.round(FileSize / 1000000); //size in mb;
		if(Max_fileSize>4)
		{
		alert('Attachment may not exceed 5MB.');
		}
		else{ 
		this.$data.sendingImage = true;
		
		var meg_number:any = '';
		var fromNumber:any = '';
		meg_number= this.TO_NUM1((this as any).selectedContact);
		fromNumber = this.$data.FromSelected_Number.toString().indexOf("+1") == -1 ? "+1"+this.$data.FromSelected_Number :  this.$data.FromSelected_Number;
		meg_number = meg_number.toString().indexOf("+1") == -1 ?  "+1" + meg_number :meg_number
		
		console.log('fromnumber here',fromNumber);
		console.log('tonumber here',meg_number);
		let formData = new FormData();
		formData.append('file', files);
		formData.append('from', fromNumber);
		formData.append('to', meg_number);
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.account.jwt;
		 axios.post( `${AppSettings.API_HOST}sendMMSFile`,formData,{	headers: {'Content-Type': 'multipart/form-data'}})
		 .then(r => {
			       const msgID = r.data.id;
				   //(this.$refs.fileInput as any).reset();
					(this.$refs.fileInputTextPanel as any).value = null;
					this.$data.filename = '';
					this.$data.textContent = '';
					this.$data.sendingImage = false;
					r.data.direction= "out";
					let d= new Date(); 
					r.data.time=  d;
					const strdate= moment(r.data.time).format('YYYY-MM-DD');
					r.data.datex=strdate;
					var index1 = this.$data.temp_Textlist.findIndex(x => x.datex ===strdate);
					r.data.displaydate=index1<0;
					r.data.messageId=msgID;
			        r.data.deliveryState = 'Sending...';
					this.$data.temp_Textlist.push(r.data);
					(this as any).text_history.push(r.data);
					var data=(this as any).text_history;
					this.text_limitcal(data);
				
					this.loadCheck();
					var scrolldown;
					console.log('sending image',r.data);
					let newNotification:any = {};
					newNotification._id = r.data.id;
					newNotification.from = fromNumber;
					newNotification.to = meg_number;
					newNotification.deliveryState = 'delivered';
					newNotification.messageId = r.data.messageId;
					newNotification.eventType = 'mms';
					newNotification.media = r.data.media;
					newNotification.direction = 'out';
					newNotification.text='Attachment: Image';
					newNotification.tag=r.data.tag;
					newNotification.applicationId =r.data.applicationId;
					newNotification.time=r.data.time;
					// var myDiv=(this as any).$refs.text_log;
					// myDiv.scrollTop = myDiv.scrollHeight+ 200;
					scrolldown = setTimeout(this.scroTobottomtext, 1000);					
					const getmessgeinfo=  this.getmessgeinfo;
					this.$store.commit('SET_SELECTED_FILE','');
					console.log('r.data.deliveryState before mms',r.data.deliveryState);
					setTimeout(async function() {
						getmessgeinfo(msgID, false, null, newNotification)
					}, 10000)

						

		//scrolldown = setTimeout(this.scroTobottom, 1000);
		}).catch(r => {
			this.$data.sendingImage = false;
			(this.$refs.fileInputTextPanel as any).value = null;
			//(this.$refs.fileInput as any).reset();
			console.log('failed', r);
		});
		}
		}

		isImage(media) {
		const re = /.+\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF|)/;
		return re.test(media);
		}

		getBandwidthTimestamp(d) {
		return moment(d).format('YYYY-MM-DD HH:mm:ss');
		}

		//Used to add a bold class to the selected option element in the phone
		// - Page 40 in dashboard v1-1
		shouldBold(number: any) {
		if(number === this.$data.selectedNumber) {
		return "bold"
		}
		}

		downloadXCLDOC() {
			if(this.$data.temp_Textlist.length!=0 )
			var self=this;
			const timestamp = (this as any).text_history[0].time;
			if (this.$data.start_date==null && this.$data.end_date==null
			||(this.$data.start_date!==null&&this.$data.end_date==null) 
			|| (this.$data.start_date==null&&this.$data.end_date!==null))
			
			{ 
			this.$message.error('Please select a date range.' );
			this.$data.date_status=true;
			// this.$data.startval = new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1))).toDateString());
			// this.$data.endval =new Date().toDateString()//
			
			}
			else
			{
			this.downloading=true;
			this.$data.date_status=false;
			setTimeout(function(){  
			self.TextExcelDoc_download();   
			}, 1000);
			}
		}


		/**
		* Download message history to  ExcelDoc file 
		*/
	    public TextExcelDoc_download() {
		this.downloading=false; 
		var Login_User=AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
		var Contact_User;
		if((this as any).selectedContact) {
		Contact_User =`${((this as any).selectedContact as any).first_name} ${((this as any).selectedContact as any).last_name}`;
		}
		else {
		Contact_User= '';
		}
		let Contact_Number ;
		if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
		Contact_Number= (this as any).selectedContact.numbers.mobile.number;
		}
		else {
		Contact_Number= '';
		}
		let Custemer_ID ;
		if(((this as any).selectedContact as any).custermerid )
		{
		Custemer_ID= ((this as any).selectedContact as any).custermerid ;
		}
		else {
		Custemer_ID= '';
		}
	
		var fromdate = this.$data.start_date;//this.$data.start_date;//
		var todate=this.$data.end_date//this.$data.end_date;//
	    if(typeof XLSX == 'undefined') var XLSX= require('xlsx');
		var wb = XLSX.utils.book_new();
		var L1;
		var L2;
		L1=moment(fromdate).format('YYYY-MM-DD');//fromdate;//this.$data.start_date;//
		L2=moment(todate).format('YYYY-MM-DD');//todate;// this.$data.end_date;//
		var data = [
		['Message History'],
		['Start Date', L1],
		['End Date',L2],
		['User', Login_User,+48646546 ],
		['Contact', Contact_User, Contact_Number],
		['Customer ID',  Custemer_ID],
		[''],
		['Date','Time','Person','Message'],
		];
		this.$data.temp_Textlist.forEach(obj =>{ 

		if (moment(obj.time).isSameOrAfter(fromdate, 'day') 
		&& moment(obj.time).isSameOrBefore(todate, 'day')
		)
		{
		var sendername= obj.direction=="in"?Contact_User:Login_User;
		data.push([moment(obj.time).format('YYYY-MM-DD'),moment(obj.time).format('h:mm A') ,sendername, obj.text]);
		}
		});
		var Chat_from =this.$data.temp_Textlist[0].from;
		Chat_from='HelloSpoke chat with'+' '+ Chat_from;
		var append_sheet='HelloSpoke chat with'+' '+this.$data.temp_Textlist[0].from;
		Chat_from=Chat_from+'.'+"xlsx";

		var wb = XLSX.utils.book_new();
		var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true,cellDates:true});
		var range = XLSX.utils.decode_range(ws["!ref"]);
		if(!ws['!cols']) ws['!cols'] = [];
		if(!ws.A1.c) ws.A1.c = [];
		//  ws.A1.c.push({a:"SheetJS", t:"This comment is visible"});
		/* TEST: merge cells */
		ws['!merges'] = [ XLSX.utils.decode_range("A1:B1") ];
		ws['!cols'][0] = { wch: 15 };
		ws['!cols'][1] = { wch: 15 };
		ws['!cols'][2] = { wch: 25 };
		ws["!margins"]={left:6.0, right:8.0, top:9.0, bottom:1.0, header:0.5,footer:0.5};
		XLSX.utils.book_append_sheet(wb, ws, "No Header");
		var wbout = XLSX.write(wb, {bookType:'xlsx', type:'array'});
		this.$data.start_date =this.$data.startval= null;
		this.$data.end_date =this.$data.endval= null;
		
		saveAs(new Blob([wbout],{type:"application/octet-stream"}), Chat_from); 
		}

		message_back(){
			this.$store.commit('CHANGE_SELECTED_CONTACT', null);
			this.$store.commit("SET_SELECTED_CONTACTS", null);
		    this.$store.commit('SET_TEXTPNL_CONTACTINFO','');this.$store.commit('SET_START_NEWTEXT','');
			this.$data.start_date = null;
		    this.$data.end_date = null;
		}

}
